/* istanbul ignore next */
const initChameleon = () => {
  // NOSONAR
  // @ts-ignore
  !(function (d, w) {
    var t = "SeaKiTPNWooj5pOMBrgVYhGXPzTdDRnGbrjCHc434kY08O-1KyCsc-CtYz02C3bfVS2SmL",
      c = "chmln",
      m = "identify alias track clear set show on off custom help _data".split(" "),
      i = d.createElement("script");
    // @ts-ignore
    if ((w[c] || (w[c] = {}), !w[c].root)) {
      // @ts-ignore
      (w[c].accountToken = t), (w[c].location = w.location.href.toString()), (w[c].now = new Date());
      for (var s = 0; s < m.length; s++) {
        // @ts-ignore
        // eslint-disable-next-line no-loop-func
        !(function () {
          // @ts-ignore
          var t = (w[c][`${m[s]}_a`] = []);
          // @ts-ignore
          w[c][m[s]] = function () {
            // @ts-ignore
            t.push(arguments);
          };
        })();
      }
      (i.src = `https://fast.trychameleon.com/messo/${t}/messo.min.js`), (i.async = !0), d.head.appendChild(i);
    }
  })(document, window);
};

export default initChameleon;
